
  import React from "react"
  import Component from "/Users/krystian/Dev/brainhubeu-react-permissible/docs-www/node_modules/@brainhubeu/gatsby-docs-kit/src/layouts/default.js"
  import data from "/Users/krystian/Dev/brainhubeu-react-permissible/docs-www/.cache/json/layout-default.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/default.js